<div class="container single-view" id="view-retailer-type">
  <div class="row">
    <div class="col-12 mb-4 flex flex-wrap items-end justify-between gap-4">
      <div id="pre-header-wr">
        <a data-testid="back-btn" href="javascript:void(0)" appBack fallbackUrl="/retailer-types" class="inline-flex items-center text-base link link-icon left-arrow">{{ 'RETAILER_TYPES.BTN_BACK_TO_RETAILER_TYPE' | translate }}</a>
      </div>
    </div>
    <div class="col-12">
      <div id="view-header-wr" class="flex flex-wrap items-baseline justify-between">
        <div class="title-wr flex flex-wrap items-center">
          <div data-testid="retailertype-item">
            <h1 data-testid="section-item" class="section-title mb-3">{{ 'RETAILER_TYPE_SINGLE_VIEW.RETAILER_TYPE_DETAILS' | translate }}
            </h1>
            <div>
              <h2 data-testid="element-item" class="element-title flex items-center gap-2">
                @if (retailerType.name) {
                  <span data-testid='retailertype-name'>{{ retailerType.name | defaultValue }}</span>
                }
              </h2>
            </div>
          </div>
        </div>
        <div class="flex flex-wrap justify-between gap-y-4 self-end">
          <div id="complementary-details" class="flex flex-wrap"></div>
          <div id="actions-wr" class="flex flex-wrap items-stretch justify-end gap-3">
            @if (allowModifyRetailerType) {
              <button data-testid='retailertype-edit-btn' class="btn primary-btn" (click)="goToEditRetailerType()">{{ 'RETAILER_TYPE_SINGLE_VIEW.BTN_EDIT' | translate }}</button>
            }
            @if (delete) {
              <button data-testid='retailertype-delete-btn' class="btn red-btn" (click)="showDeleteDialog()">{{'RETAILER_TYPES.BTN_DELETE' | translate }}</button>
            }
          </div>
        </div>
      </div>
      <hr role="presentation" class="w-full mb-3 mt-4 border-t">
      <div class="view-content-wr">
        <div class="row">
          <div class="flex flex-col col-12 mb-2 text-wr">
            <!-- main content -->
            <section class="row">
              <div class="col-12">
                <h4 data-testid="retailertype-details">{{ 'RETAILER_TYPE_SINGLE_VIEW.DETAILS' | translate }}</h4>
                <hr role="presentation" class="w-full mb-2 mt-3 border-t">
                <dl class="details-grid">
                  <dt data-testid="retailertype-name-label" class="label grid-cols-1 pt-3">{{ 'RETAILER_TYPE_SINGLE_VIEW.NAME' | translate }}</dt>
                  <dd data-testid="retailertype-name" class="value pt-3 pb-3">{{ retailerType.name | defaultValue }}</dd>

                  <dt data-testid="retailertype-code-label" class="label grid-cols-1 pt-3">{{ 'RETAILER_TYPE_SINGLE_VIEW.CODE' | translate }}</dt>
                  <dd data-testid="retailertype-code" class="value pt-3 pb-3">{{ retailerType.code | defaultValue }}</dd>

                  <dt data-testid="retailertype-hasparent-label" class="label grid-cols-1 pt-3">{{ 'RETAILER_TYPE_SINGLE_VIEW.HAS_PARENT' | translate }}</dt>
                  <dd data-testid="retailertype-hasparent" class="value pt-3 pb-3">{{ (retailerType.parent ? 'BOOLEANS.YES' : 'BOOLEANS.NO') | translate }}</dd>

                  @if (retailerType.parent) {
                    <dt data-testid="retailertype-parent-retailertype-label" class="label grid-cols-1 pt-3">{{ 'RETAILER_TYPE_SINGLE_VIEW.PARENT_NAME' | translate }}</dt>
                    <dd class="value pt-3 pb-3">
                      @if (retailerType.parent.id) {
                        <a data-testid="retailertype-parent-retailertype" [routerLink]="['/retailer-types/', retailerType.parent.id]" class="inline-flex items-center link">{{ retailerType.parent.name }}</a>
                      } @else {
                        {{ retailerType.parent.name | defaultValue }}
                      }
                    </dd>
                    <dt data-testid="retailertype-parentcode-label" class="label grid-cols-1 pt-3">{{ 'RETAILER_TYPE_SINGLE_VIEW.PARENT_CODE' | translate }}</dt>
                    <dd data-testid="retailertype-parentcode" class="value pt-3 pb-3">{{ retailerType.parent.code | defaultValue }}</dd>
                  }
                </dl>
              </div>
            </section>
            <!-- /main content -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Delete retailer type-->
<dialog-reason  #dialog [title]="'MODALBOXES.TITLE_CONFIRM_DELETE_RETAILER'" (onClose)="deleteRetailerType($event)"></dialog-reason>
